module.exports = __webpack_public_path__ + "static/media/Kaya_2026_PDF.cbf7cd96.pdf";